import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SecondaryButtonStyled } from '~/styles';

export const GeneralContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  pt: { sm: '500' },
  m: { sm: '400' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    height: 93vh;
    border-radius: 4px;
  `}
`;

export const HRStyled = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.grey[300]};
  margin-top: ${({ theme }) => theme.spacings[300]};
  margin-bottom: ${({ theme }) => theme.spacings[700]};
`;

export const FooterStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
  justifyContent: { sm: 'space-between' },
  gap: { sm: '500' },
})`
  width: 100%;
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadowInverted};
`;

export const CancelButtonStyled = styled(SecondaryButtonStyled)`
  ${({ theme }) => css`
    border-color: ${theme.colors.blue[400]};
    padding: ${theme.spacings[400]} ${theme.spacings[600]};
  `}
`;
